import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

const openPdf = async (url) => {
  try {
    const r = await api.get(url, { responseType: "blob" });
    window.open(URL.createObjectURL(r.data), "_blank");
  } catch (e) { toast.error(e?.response?.data?.detail || "PDF impossible"); }
};

// Partenariat institutionnel (Cégep) : participation par cycle de 28 j + facture consolidée (brouillon → émise). Aucun Stripe, aucun envoi.
export function CycleReportPanel({ session }) {
  const [start, setStart] = useState(session.start_date || "");
  const [pp, setPp] = useState("");
  const [pass, setPass] = useState("");
  const [formula, setFormula] = useState("banque_presences");
  const [rep, setRep] = useState(null);
  const q = () => `cycle_start=${start}&price_presence=${pp || 0}&price_pass=${pass || 0}&formula=${formula}`;
  const load = () => {
    if (!start) return;
    api.get(`/ecoles/sessions/${session.id}/cycle-report?${q()}`).then((r) => setRep(r.data)).catch(() => toast.error("Rapport impossible"));
  };
  useEffect(() => { load(); }, [start, pp, pass, formula]); // eslint-disable-line react-hooks/exhaustive-deps
  const r = rep?.report;
  const shift = (n) => { if (!start) return; const d = new Date(start + "T12:00:00"); d.setDate(d.getDate() + n * 28); setStart(d.toISOString().slice(0, 10)); };
  const verify = async (x) => {
    try { await api.patch(`/ecoles/sessions/${session.id}/enrollments/${x.idx}/partner`, { student_card_verified: !x.student_card_verified }); load(); }
    catch { toast.error("Erreur"); }
  };
  const emit = async () => {
    if (!window.confirm(`Émettre la facture officielle pour le cycle ${r.cycle_start} → ${r.cycle_end} (${r.total.toFixed(2)} $) ? Un numéro sera attribué.`)) return;
    await openPdf(`/ecoles/sessions/${session.id}/cycle-report/invoice.pdf?${q()}&final=true`);
    load();
  };
  return (
    <div className="border-t border-zinc-800 pt-3 space-y-2" data-testid="cycle-report-panel">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs font-semibold text-zinc-400">📊 Rapport cycle 28 j (partenariat)</span>
        <Button size="sm" onClick={() => shift(-1)} className="h-7 w-7 p-0 bg-zinc-800 hover:bg-zinc-700" data-testid="cycle-prev">‹</Button>
        <Input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="bg-zinc-900 border-zinc-800 h-8 text-xs w-36" data-testid="cycle-start" />
        <Button size="sm" onClick={() => shift(1)} className="h-7 w-7 p-0 bg-zinc-800 hover:bg-zinc-700" data-testid="cycle-next">›</Button>
        <select value={formula} onChange={(e) => setFormula(e.target.value)} className="bg-zinc-900 border border-zinc-800 rounded h-8 text-xs text-zinc-200 px-1" data-testid="cycle-formula">
          <option value="banque_presences">Banque de présences</option>
          <option value="passe_4_semaines">Passe 4 semaines</option>
        </select>
        <Input type="number" placeholder="$/présence" value={pp} onChange={(e) => setPp(e.target.value)} className="bg-zinc-900 border-zinc-800 h-8 text-xs w-24" data-testid="cycle-price-presence" />
        <Input type="number" placeholder="$/passe" value={pass} onChange={(e) => setPass(e.target.value)} className="bg-zinc-900 border-zinc-800 h-8 text-xs w-24" data-testid="cycle-price-pass" />
      </div>
      {r && (
        <>
          <p className="text-[11px] text-zinc-500" data-testid="cycle-summary">
            Cycle {r.cycle_no ? `n° ${r.cycle_no} · ` : ""}{r.cycle_start} → {r.cycle_end} · {r.classes_held} séance(s) · {r.students_active}/{r.students_enrolled} actifs · {r.total_presences} présences (moy. {r.avg_presences})
            {r.unverified.length > 0 && <span className="text-amber-300"> · ⚠️ carte étudiante non vérifiée : {r.unverified.join(", ")}</span>}
          </p>
          <table className="w-full text-xs" data-testid="cycle-table">
            <thead className="text-zinc-500 text-left"><tr><th className="py-1">Étudiant(e)</th><th>Présences</th><th>Assiduité</th><th>Facturable</th><th className="text-right">Montant</th></tr></thead>
            <tbody>
              {r.rows.map((x, i) => (
                <tr key={i} className="border-t border-zinc-800/60" data-testid={`cycle-row-${i}`}>
                  <td className="py-1 text-zinc-200">{x.student_name}
                    <button onClick={() => verify(x)} title={x.student_card_verified ? "Carte étudiante vérifiée" : "Marquer la carte étudiante comme vérifiée"} className={`ml-1 text-[10px] px-1 rounded ${x.student_card_verified ? "text-emerald-300 bg-emerald-900/40" : "text-zinc-500 bg-zinc-800"}`} data-testid={`cycle-verify-${i}`}>{x.student_card_verified ? "carte ✓" : "carte ?"}</button>
                  </td>
                  <td className="text-zinc-300">{x.presences}</td>
                  <td className="text-zinc-400">{x.attendance_rate} %</td>
                  <td className="text-zinc-400">{x.billable} × {x.unit_price.toFixed(2)} $</td>
                  <td className="text-right text-zinc-100">{x.amount.toFixed(2)} $</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="text-xs text-zinc-300" data-testid="cycle-totals">Sous-total {r.subtotal.toFixed(2)} $ · TPS {r.tps.toFixed(2)} $ · TVQ {r.tvq.toFixed(2)} $ · <b className="text-[#C9A961]">Total {r.total.toFixed(2)} $</b></span>
            <div className="flex gap-2">
              <Button size="sm" onClick={() => openPdf(`/ecoles/sessions/${session.id}/cycle-report/invoice.pdf?${q()}`)} className="h-7 text-[11px] bg-zinc-800 hover:bg-zinc-700" data-testid="cycle-invoice-draft">📄 Facture brouillon</Button>
              <Button size="sm" onClick={emit} disabled={r.subtotal <= 0 || rep.invoices.length > 0} className="h-7 text-[11px] bg-[#C9A961] text-black hover:bg-[#d8b96e] disabled:opacity-50" data-testid="cycle-invoice-final">
                {rep.invoices.length > 0 ? `✓ ${rep.invoices[0].number} émise` : "🧾 Émettre la facture"}
              </Button>
            </div>
          </div>
          {rep.invoices.length > 0 && <button onClick={() => openPdf(`/ecoles/sessions/${session.id}/cycle-report/invoice.pdf?${q()}&final=true`)} className="text-[11px] text-[#C9A961] underline" data-testid="cycle-invoice-open">Ouvrir la facture {rep.invoices[0].number}</button>}
        </>
      )}
    </div>
  );
}
